/**
 * Normaliza texto para comparação de busca: remove acentos (NFD), ignora
 * caixa e corta espaços nas pontas. Usado por `app-search-select` para achar
 * "São Paulo" ao digitar "sao paulo" — não tem relação com o `global-search`
 * do painel, que resolve um problema diferente (busca cross-entidade).
 */
export function normalizeForSearch(text: string | null | undefined): string {
  return (text ?? '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .trim();
}
